/* import __COLOCATED_TEMPLATE__ from './function-call-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import type { FormattedConversationFunctionCall } from '../conversation-item';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

export interface ConversationArgs {
  conversationItem: FormattedConversationFunctionCall;
  verboseLogsEnabled: boolean;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class FunctionCallConversationItem extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked isExpanded = false;

  get formattedLoadingText() {
    return this.intl.t('ai-agent.voice-playground.conversation.tool-in-progress', {
      toolName: this.args.conversationItem.toolName,
    });
  }

  get formattedToolName() {
    return this.intl.t('ai-agent.voice-playground.conversation.tool-called', {
      toolName: this.args.conversationItem.toolName,
    });
  }

  get formattedToolArguments() {
    return JSON.stringify(this.args.conversationItem.toolArguments, null, 2);
  }

  get formattedToolOutput() {
    return this.intl.t('ai-agent.voice-playground.conversation.tool-output', {
      toolOutput: this.args.conversationItem.toolOutput
        ? this.args.conversationItem.toolOutput
        : this.intl.t('ai-agent.voice-playground.conversation.tool-output-empty'),
    });
  }

  @action
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::FunctionCallConversationItem': typeof FunctionCallConversationItem;
  }
}
